import {Tag} from "antd";
import {
  StyledServiceOrderCard,
  StyledServiceOrderCardBody,
  StyledServiceOrderCardBodyContent,
  StyledServiceOrderCardBodyContentDetails,
  StyledServiceOrderCardBodyContentDetailsItem,
  StyledServiceOrderCardBodyContentHeader,
  StyledServiceOrderCardBodyContentHeaderDetails,
  StyledServiceOrderCardBodyContentHeaderOrderTime,
  StyledServiceOrderCardContentButtonWrapper,
  StyledServiceOrderCardSideCap,
} from "./styles";
import {OrderFilterOptionValue} from "../header/filter";
import {GetStoreServicesOrdersApiResponse} from "../../../../../react-query-hooks/store/services/get-orders/types";
import moment from "moment";
import {mapStatusIdToStatus} from "../list/list";

export type OrderFilterOptionValueWithoutIncomplete = Exclude<
  OrderFilterOptionValue,
  "incomplete"
>;

export type ServiceOrderCardProps = {
  order: GetStoreServicesOrdersApiResponse["orders"][0];
  onShowDetails: () => void;
};

export const orderStatusTags: Record<OrderFilterOptionValueWithoutIncomplete, string> = {
  inprogress: "In progress",
  completed: "Completed",
  delivered: "Delivered",
  disputeOpened: "Dispute opened",
  refunded: "Refunded",
  cancelled: "Cancelled",
};
export const orderStatusColors: Record<OrderFilterOptionValueWithoutIncomplete, string> =
  {
    inprogress: "#fffbe6",
    completed: "#f6ffed",
    delivered: "#e6fffb",
    disputeOpened: "#fff1f0",
    refunded: "#fff2E8",
    cancelled: "#fafafa",
  };
export const orderStatusTagColors: Record<
  OrderFilterOptionValueWithoutIncomplete,
  string
> = {
  inprogress: "gold",
  completed: "green",
  delivered: "cyan",
  disputeOpened: "red",
  refunded: "volcano",
  cancelled: "default",
};
export function ServiceOrderCard({onShowDetails, order}: ServiceOrderCardProps) {
  const customerName = `${order.firstName} ${order.lastName}`;
  const deliveryDate = moment(order.delivery_date).format("MMMM DD, YYYY");
  const orderTime = `Ordered ${moment(order.createdAt).fromNow()}`;
  const startDate = moment(order.createdAt).format("MMMM DD, YYYY");
  const price = +order.amount > 0 ? `${order.currency} ${order.amount}` : "Free";
  const projectName = order.productService.name;
  const status = mapStatusIdToStatus(order.statusId);
  const orderStatus = orderStatusTags[status];

  return (
    <>
      <StyledServiceOrderCard>
        <StyledServiceOrderCardContentButtonWrapper onClick={onShowDetails} />
        <StyledServiceOrderCardSideCap $status={status} />
        <StyledServiceOrderCardBody>
          <StyledServiceOrderCardBodyContent>
            <StyledServiceOrderCardBodyContentHeader>
              <StyledServiceOrderCardBodyContentHeaderOrderTime>
                {orderTime}
              </StyledServiceOrderCardBodyContentHeaderOrderTime>
              <StyledServiceOrderCardBodyContentHeaderDetails>
                <p className="project-name">{projectName}</p>
                <Tag color={orderStatusTagColors[status]} title="In progress">
                  {orderStatus}
                </Tag>
              </StyledServiceOrderCardBodyContentHeaderDetails>
            </StyledServiceOrderCardBodyContentHeader>
            <StyledServiceOrderCardBodyContentDetails>
              <StyledServiceOrderCardBodyContentDetailsItem>
                <p>
                  Customer: <span className="item-value">{customerName}</span>
                </p>
              </StyledServiceOrderCardBodyContentDetailsItem>
              <StyledServiceOrderCardBodyContentDetailsItem>
                <p>
                  Price: <span className="item-value">{price}</span>
                </p>
              </StyledServiceOrderCardBodyContentDetailsItem>
              <StyledServiceOrderCardBodyContentDetailsItem>
                {status === "completed" ? (
                  <p>
                    Order timeline:{" "}
                    <span className="item-value">{`${startDate} - ${deliveryDate}`}</span>
                  </p>
                ) : (
                  <p>
                    Est. delivery date: <span className="item-value">{deliveryDate}</span>
                  </p>
                )}
              </StyledServiceOrderCardBodyContentDetailsItem>
            </StyledServiceOrderCardBodyContentDetails>
          </StyledServiceOrderCardBodyContent>
        </StyledServiceOrderCardBody>
      </StyledServiceOrderCard>
    </>
  );
}
